import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Охотничный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Интенсивность приема иностранных туристов для занятий охотой зависит от возможностей охотничьих
                        хозяйств, которые определяют количество лицензий, ежегодно продаваемых любителям охоты из-за
                        рубежа. Спрос на такие поездки достаточно большой, ведь наша страна обладает такими охотничьими
                        ресурсами, которых нет в других странах.</p>
                    <p>Территория Брестской области обладает лесными, полевыми и водно-болотными угодьями общей площадью
                        2908,9 га, используемых для охотничьего туризма. Услуги охотничьего туризма предоставляются 22
                        хозяйствами и организациями области, в т.ч.:</p>
                    <div className="two-col-cell">
                        <ul>
                            <li>центр охотничьего и рыболовного туризма на о. Выгонощанское и в районе Ружанской пущи;</li>
                            <li>организация специализированных туров для иностранных туристов с фотоохотой;</li>
                            <li>ГНП «Беловежская пуща» и производственное лесохозяйственное объединение;</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}